<script setup lang="ts">
import { ref } from 'vue'
import { Color } from '@previo/codebooks'
import { $t } from '../../../../composables/i18n'
import PModalDialog from '../../../dialog/PModalDialog.vue'
import PTextStandard from '../../../typography/body/PTextStandard.vue'

type Props = {
  goToRoute: string | null
}

type Emits = {
  (e: 'redirect', route: string | null): void
}
defineProps<Props>()

const isOpen = defineModel<boolean>({ default: false })
const loading = ref<boolean>(false)
const emits = defineEmits<Emits>()
</script>

<template>
  <p-modal-dialog
    v-model="isOpen"
    :title="$t('Setting is modify')"
    :primary-btn="$t('Continue without save')"
    :primary-btn-color="Color.NEGATIVE_STATE"
    :primary-btn-loading="loading"
    :tertiary-btn="$t('Cancel')"
    :tertiary-btn-color="Color.NEGATIVE"
    :tertiary-btn-loading="loading"
    cy="setting-is-modify"
    @primary="emits('redirect', goToRoute)"
    @tertiary="isOpen = false"
  >
    <p-text-standard :text="$t('Do you really wish to continue without saving?')" />
  </p-modal-dialog>
</template>
